import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  orderBy,
  getDoc,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  updateDoc,
  arrayUnion,
  // Pagination
  limit,
  startAfter,
  //
  where,
} from "firebase/firestore";

const studentsModule = {
  namespaced: true,
  state: {
    studentsList: [],
    studentContent: [],
    updateStudent: {},
    isLoading: true,
    isFirstLoad: true,
    // Pagination
    loadingMore: false,
    showLoadingButton: true,
    lastVisible: "",
    orderBy: "created_date",
    // Search
    searchResult: [],
  },
  getters: {
    getStudents: (state) =>
      state.studentsList.map((e) => ({
        ...e,
        grade_id: e?.grade?.category_id || e?.grade?.id,
      })),
    getStudentContent: (state) => state.studentContent,
    getUpdateStudent: (state) => state.updateStudent,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
    // Pagination
    isLoadingMore: (state) => state.loadingMore,
    isShowLoadingButton: (state) => state.showLoadingButton,
    // Search
    getSearchResult: (state) => state.searchResult,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All Students
    setStudents: (state, payload) => {
      state.studentsList = payload;
    },

    // Add Student
    addStudent: (state, payload) => {
      if (state.studentsList.length > 0) state.studentsList.unshift(payload);
      else state.studentsList = [payload];
    },

    // get Student by id
    getSelectStudent: (state, payload) => {
      state.updateStudent = payload;
    },

    //
    // Get Search Result
    setSearchResult: (state, payload) => {
      state.searchResult = payload;
    },
    // Update Student
    updateStudent: (state, payload) => {
      const findIndex = state.studentsList.findIndex(
        (student) => student.student_id == payload.student_id
      );
      state.studentsList[findIndex] = payload;
    },

    // Delete Student
    deleteStudent: (state, payload) => {
      const findIndex = state.studentsList.findIndex(
        (student) => student.student_id == payload
      );
      state.studentsList.splice(findIndex, 1);
    },

    //---- Contents

    // Get All Students
    setStudentContent: (state, payload) => {
      state.studentContent = payload;
    },
    // Add Student
    addContent: (state, payload) => {
      if (state.studentContent.length > 0)
        state.studentContent.unshift(payload);
      else state.studentContent = [payload];
    },

    // Renew Views
    renewView: (state, payload) => {
      const findIndex = state.studentContent.findIndex(
        (content) => content.content_id == payload
      );
      state.studentContent[findIndex].number_of_views = 3;
    },

    // Delete Content in Student
    deleteContent: (state, payload) => {
      const findIndex = state.studentContent.findIndex(
        (content) => content.content_id == payload
      );
      state.studentContent.splice(findIndex, 1);
    },
    //-------------------on Select---------------------
    // Update
    updateStudentsList: (state, payload) => {
      payload.students.forEach((student) => {
        const findIndex = state.studentsList.findIndex(
          (stu) => stu.student_id == student.student_id
        );
        state.studentsList[findIndex].fullClassesInfo.push(
          ...payload.fullClassesInfo
        );
        state.studentsList[findIndex].classes.push(...payload.classes);
      });
    },

    // Pagination and Sort and Search
    setData: (state, payload) => {
      state.studentsList = payload;
    },
    setLastVisible: (state, payload) => {
      state.lastVisible = payload;
    },
    setOrderBy: (state, payload) => {
      state.orderBy = payload;
    },
    setNextData: (state, payload) => {
      state.studentsList.push(...payload);
    },
    setShowLoadingButton: (state, payload) => {
      state.showLoadingButton = payload;
    },
    setLoadingMore: (state, payload) => {
      state.loadingMore = payload;
    },
  },
  actions: {
    //---- Pagination
    async getFirstData({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const data = await getDocs(
        query(
          collection(db, "Students"),
          orderBy(this.state.studentsModule.orderBy),
          limit(10)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setLastVisible", lastVisible);
      let dataArray = [];
      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ student_id: doc.id, ...doc.data() });
        });
      } else {
        dataArray = false;
      }
      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }
      commit("setData", dataArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
    },

    async getNextData({ commit }) {
      commit("setLoadingMore", true);
      const data = await getDocs(
        query(
          collection(db, "Students"),
          orderBy(this.state.studentsModule.orderBy),
          limit(10),
          startAfter(this.state.studentsModule.lastVisible)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setLastVisible", lastVisible);
      let dataArray = [];
      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ student_id: doc.id, ...doc.data() });
        });
      }
      commit("setNextData", dataArray);
      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }
      commit("setLoadingMore", false);
    },
    changeSorting({ commit }, payload) {
      commit("setOrderBy", payload);
    },
    // ----- Search
    async searchData({ commit }, payload) {
      commit("setFirstLoad", false);
      console.log(payload);

      const data = await getDocs(
        query(
          collection(db, "Students"),
          where("name", ">=", payload),
          limit(10)
        )
      );
      let dataArray = [];
      data.forEach((doc) => {
        dataArray.push({ code_id: doc.id, ...doc.data() });
      });
      commit("setSearchResult", dataArray);
    },

    // Add Student
    async addStudent({ commit }, payload) {
      const documentReference = doc(collection(db, "Students"));
      const student = {
        ...payload,
        student_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, student);
      commit("addStudent", student);
      return student;
    },

    // get Studnet by id
    async getStudentById({ commit }, payload) {
      let studentSelect = await getDoc(doc(db, "Students", payload));
      commit("getSelectStudent", studentSelect.data());
      return studentSelect.data();
    },

    // Update Student
    async updateStudent({ commit }, payload) {
      updateDoc(doc(db, "Students", payload.student_id), payload);
      commit("updateStudent", payload);
    },

    // Delete Student
    async deleteStudent({ commit }, payload) {
      deleteDoc(doc(db, "Students", payload));
      commit("deleteStudent", payload);
    },

    //----Content
    // Add student collection to class
    async addContentToStudentsClass({ commit }, payload) {
      // let students;
      payload.studentIDs.forEach((studentId) => {
        const documentReference = doc(
          db,
          `Students/${studentId}/codes`,
          payload.code.content_id
        );
        const content = {
          ...payload.code,
          created_date: new Date(),
        };
        setDoc(documentReference, content);
        commit("addContent", content);
      });

      commit("setFirstLoad", false);
    },

    // get Sub Collection Codes
    async getSubCollection({ commit }, payload) {
      commit("setLoading", true);
      let studentContent = [];
      const studentSubContent = await getDocs(
        query(
          collection(db, `Students/${payload}/codes`),
          orderBy("created_date", "desc")
        )
      );

      console.log(studentSubContent);

      if (!studentSubContent.empty) {
        studentSubContent.forEach((doc) => {
          studentContent.push({ ...doc.data() });
        });
      } else {
        console.log("The Student Don't have any Contents");
        studentContent = false;
      }
      commit("setStudentContent", studentContent);
      commit("setLoading", false);
    },

    // get Sub Collection Codes
    async addContentToSudent({ commit }, payload) {
      const documentReference = doc(
        db,
        `Students/${payload.id}/codes`,
        payload.code.content_id
      );
      const content = {
        ...payload.code,
        created_date: new Date(),
      };
      setDoc(documentReference, content);
      commit("addContent", content);
    },

    // Renew Views
    renewContentViews({ commit }, payload) {
      updateDoc(
        doc(db, `Students/${payload.student_id}/codes`, payload.content_id),
        {
          number_of_views: 3,
          date_of_usage: null,
        }
      );
      commit("renewView", payload.content_id);
    },

    // Delete Sub Collection
    deleteContentFromStudent({ commit }, payload) {
      deleteDoc(
        doc(db, `Students/${payload.student_id}/codes`, payload.content_id)
      );
      commit("deleteContent", payload.content_id);
    },

    //--------------------------------
    // On Select
    deleteStudents({ commit }, payload) {
      payload.forEach((student) => {
        deleteDoc(doc(collection(db, "Students"), student.student_id));
        commit("deleteStudent", student.student_id);
      });
    },

    addClassesToStudents({ commit }, payload) {
      for (let i = 0; i < payload.students.length; i++) {
        updateDoc(
          doc(db, `Students/${payload.students[i].student_id}`),
          {
            classes: arrayUnion(...payload.classes),
            fullClassesInfo: arrayUnion(...payload.fullClassesInfo),
          },
          { merge: true }
        );
      }

      commit("updateStudentsList", payload);
    },

    addClassToStudents({ commit }, payload) {
      for (let i = 0; i < payload.students.length; i++) {
        updateDoc(
          doc(db, `Students/${payload.students[i]}`),
          {
            classes: arrayUnion(payload.classes),
            fullClassesInfo: arrayUnion(payload.fullClassesInfo),
          },
          { merge: true }
        );
      }

      commit("setFirstLoad", false);
    },
  },
};

export default studentsModule;
